import { render, staticRenderFns } from "./PdpDeliveryOptions.vue?vue&type=template&id=7a42d708&scoped=true&"
import script from "./PdpDeliveryOptions.vue?vue&type=script&lang=js&"
export * from "./PdpDeliveryOptions.vue?vue&type=script&lang=js&"
import style0 from "./PdpDeliveryOptions.vue?vue&type=style&index=0&id=7a42d708&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a42d708",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppPlaceAutocomplete: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppPlaceAutocomplete.vue').default})
